import type { RankingResult } from '@core-api/presentation/types/response';
import { useFetchRankingResults } from '@mentimeter/presentation-data-hooks/fetch-ranking-results';

interface UseRankingResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useRankingResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseRankingResultsParams): {
  results: RankingResult[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchRankingResults({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  return {
    results: data?.results ?? [],
    isLoading,
  };
};
